(function(angular) {
    'use strict';
    var app = angular.module('enervee.account');

    /*
    EmailSettingsService is responsible for making account email settings page api calls and model level calculations
    */

    app.factory('EmailSettingsService', [
        'UserApiConsumerService',
        function(
            UserApiConsumerService
        ) {
            var _pub = {},
                _emailSubscriptionInfo;

            /**
             * Fetches the current email subscriptions
             *
             * @returns {*}
             */
            _pub.fetchEmailSubscriptionInfo = function () {

                return UserApiConsumerService.get('api/1.0/email/subscription/').then(function(response) {
                    _emailSubscriptionInfo = response.data;
                },
                function(error) {
                    _emailSubscriptionInfo = {};
                });

            };

            /**
             * Gets the current email subscriptions
             *
             * @returns {*}
             */
            _pub.getEmailSubscriptionInfo = function () {

                return _emailSubscriptionInfo;

            };


            /**
             * Saves the new email subscriptions
             *
             * @returns {*}
             */
            _pub.saveEmailSubscriptionInfo = function (emailSettings) {

                return UserApiConsumerService.post('api/1.0/email/subscription/', emailSettings).then(function (response) {
                    _emailSubscriptionInfo = response.data;
                });

            };


            return _pub;
        }
    ]);

})(angular);
